export enum AuthorityCodesDashboard {
  financialView = '7.1.2',
  estimatorView = '7.1.1',
  managerView = '9.1',
  defaultView = '7.1',
}

export interface Authorities {
  authorityType: string;
  code: AuthorityCodesDashboard;
  description: string;
  id: number;
}
